import { AdvisoryInfoIcon } from '../../components/icons/Icons.tsx';
import { SecondaryAdvisory } from '../SecondaryAdvisory.tsx';
import { AdvisoryLink } from './AdvisoryLink.tsx';

export const NOTAMAdvisory = () => {
    return (
        <SecondaryAdvisory header="Notices to Air Missions Warning" advisoryType='advise' icon={AdvisoryInfoIcon} iconColor="medium">
            Please review Notices to Air Missions (NOTAMs) for your flight area at <AdvisoryLink url="https://notams.aim.faa.gov/notamSearch" />.
        </SecondaryAdvisory>
    );
};
